//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { truncate } from 'lodash'
import OccupationLocation from '@/components/freelancer/OccupationLocation'
import FreelancerRate from '@/components/freelancer/FreelancerRate'
import AvatarDisplay from '@/components/ui/AvatarDisplay'
import TagsDisplay from '@/components/ui/TagsDisplay'
import WebPresenceGroup from '@/components/profile/WebPresenceGroup'
import BcCheckStatus from '@/components/common/BcCheckStatus'
import CopyProfileUrl from '@/components/profile/CopyProfileUrl'
import ShareButtons from '@/components/ui/ShareButtons'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'BasicInfoPreview',
  components: {
    FreelancerRate,
    AvatarDisplay,
    TagsDisplay,
    WebPresenceGroup,
    BcCheckStatus,
    OccupationLocation,
    CopyProfileUrl,
    ShareButtons
  },
  props: {
    freelancer: {
      type: Object,
      default () {
        return {}
      }
    },
    skillsClickable: {
      type: Boolean,
      default: false
    },
    avatarOptions: {
      type: Object,
      default () {
        return {
          resize: {
            width: 240,
            height: 240
          }
        }
      }
    }
  },
  computed: {
    bio () {
      if (this.freelancer?.bio) {
        const striped = this.freelancer?.bio?.replace(/(<([^>]+)>)/ig, '')
        return truncate(striped, {
          length: 200,
          separator: ' '
        })
      }

      return ''
    },

    skills () {
      const currentLanguage = this.$store.getters['util/getCurrentLanguage']
      const freelancerSkills = this.freelancer?.skills || []
      const skillIds = freelancerSkills.map(s => s.id)

      if (freelancerSkills && currentLanguage) {
        const skills = this.$store.getters['util/getAllSkills']

        return skills.filter(s => skillIds.includes(s.id))
      }

      return []
    },

    /**
     * @return {Number}
     */
    profileId () {
      return this.freelancer?.id
    },

    profileUrl () {
      return `freelancers/${this.freelancer?.slug}/${this.freelancer?.id}`
    },

    slug () {
      return this.freelancer?.slug
    },

    avatar () {
      return this.freelancer?.avatar
    },

    name () {
      return this.freelancer?.name
    }
  }
}
